import { AdminType, APIGet, APIUrl, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { formatDate } from "helpers/Helpers";
import { ITeeTime } from "redux/reducers/models/teetime";

const apiVersion = "2024-04";
const baseUrl = "/" + apiVersion + "/customer";

interface IGetTeeTimes {
  facility_id: number;
  date: Date | string;
  id?: number;
  extended?: boolean;
  turn_tee_time?: boolean;
  league_id?: number;
  tee_sheet?: boolean;
  lottery_id?: number;
  course_id?: number;
}

interface IGetTeeTimeCustomerResponse extends IAPIResponse {
  data: ITeeTime[];
}

interface IGetTeeTimeAccessCode {
  facility_id: number;
  date: string;
  access_code: string;
  tee_sheet?: boolean; // For the client portal tee sheet view
  extended?: boolean;
  turn_tee_time?: boolean;
  id?: number;
}

//GET Customer bookings
export async function GetTeeTimesCustomer(
  params: IGetTeeTimes,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IGetTeeTimeCustomerResponse> {
  const convertedParams = {
    ...params,
    date: typeof params?.date === "string" ? params?.date : formatDate(params?.date)?.toString(),
  };
  return await APIGet(baseUrl + "/tee-time", convertedParams, useGlobalLoader, cancelToken);
}

export async function GetTeeTimesAccessCode(
  params: IGetTeeTimeAccessCode,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IGetTeeTimeCustomerResponse> {
  return await APIGet(APIUrl(AdminType.Customer, "/tee-time/access-code"), params, useGlobalLoader, cancelToken);
}

interface IGetTeeTimePromotionDates {
  facility_id: number;
  start_date: string;
  end_date: string;
}

export async function GetTeeTimePromotionDates(
  params: IGetTeeTimePromotionDates,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<string[]>> {
  return await APIGet(baseUrl + "/tee-time/promotion-dates", params, useGlobalLoader, cancelToken);
}